var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboInStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 0C3.97301 0 0.833008 3.14 0.833008 7C0.833008 10.86 3.97301 14 7.83301 14C11.693 14 14.833 10.86 14.833 7C14.833 3.14 11.693 0 7.83301 0ZM7.83301 12.78C4.64634 12.78 2.05301 10.1867 2.05301 7C2.05301 3.81333 4.64634 1.22 7.83301 1.22C11.0197 1.22 13.613 3.81333 13.613 7C13.613 10.1867 11.0197 12.78 7.83301 12.78Z",
    fill: "#188B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57324 9.99349V9.04682C6.57324 8.96016 6.61324 8.87349 6.67991 8.81349L8.25991 7.23349C8.39324 7.10016 8.39324 6.89349 8.25991 6.76016L6.67991 5.18016C6.61991 5.12016 6.57991 5.03349 6.57991 4.94682V4.00682C6.57991 3.70682 6.93991 3.56016 7.15324 3.76682L10.1466 6.76016C10.2799 6.89349 10.2799 7.10016 10.1466 7.23349L7.14658 10.2335C6.93324 10.4468 6.57324 10.2935 6.57324 9.99349Z",
    fill: "#188B3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboInStock);
export default __webpack_public_path__ + "static/media/FBOInStock.9d47ef7227708826d225fb01e1cd9b66.svg";
export { ForwardRef as ReactComponent };